import DOMPurify from "dompurify";
import React, {useMemo} from "react";
import {SprintTaskList} from "../SprintTaskList";
import {
    useActiveDataVersionSelector,
    useSprintDataSelector
} from "../../../../../../../store/selectors/project.selectors";


export default function SprintReport() {
    const sprintData = useSprintDataSelector();
    const activeDataVersion = useActiveDataVersionSelector();

    const activeSprint = useMemo(() => {
        if (!sprintData || !activeDataVersion) return null;
        return sprintData.find(sprint => sprint.dataVersionId === activeDataVersion.version.dataVersionId);
    }, [sprintData, activeDataVersion]);

    console.log(activeSprint);

    const cleanHtml = useMemo(() => {
        if (!activeSprint || !activeSprint.sprintReport) return null

        const cleanSprintReport = activeSprint.sprintReport
            .replace('```jsx\n', '')
            .replace('```html\n', '')
            .replace('```', '').trim();
        return DOMPurify.sanitize(cleanSprintReport);
    }, [activeSprint]);

    return cleanHtml ? (
        // <div className="sprint-report-container">
        //     {cleanHtml}
        // </div>
        <div
            className="ai-html"
            dangerouslySetInnerHTML={{ __html: cleanHtml }}
        />
    ) : null;
}